import React, { useEffect, useState } from 'react';
import axios from 'axios';
import * as Routes from '@/modules/routes';

// AIDEV-NOTE: The masquerade is session-wide, so starting one in another tab makes every request from an
// open dashboard ask as that teacher. GradeSyncController answers those with error: 'masquerading'
// rather than a 404, and this turns them into one notice with the way back, instead of a broken page.
const MasqueradeNotice = () => {
  const [impersonating, setImpersonating] = useState<string | null>(null);

  useEffect(() => {
    const interceptor = axios.interceptors.response.use(undefined, (error) => {
      const body = error?.response?.data;

      if (error?.response?.status === 403 && body?.error === 'masquerading') {
        setImpersonating(body.impersonating ?? 'a teacher');
      }

      return Promise.reject(error);
    });

    return () => axios.interceptors.response.eject(interceptor);
  }, []);

  if (impersonating == null) return null;

  const back = Routes.back_staffer_masquerade_index_path({
    to_path: `${window.location.pathname}${window.location.search}`,
  });

  return (
    <div
      className="tw-mx-auto tw-mt-4 tw-max-w-[1400px] tw-rounded tw-border tw-border-solid tw-border-spa-border
        tw-bg-spa-bg-secondary tw-px-4 tw-py-3 tw-text-sm tw-text-spa-primary"
      role="alert"
    >
      {`You are impersonating ${impersonating} in another tab, so Grade Sync can't load as you. `}
      <a className="tw-text-spa-accent-text tw-underline hover:tw-text-spa-accent-text-hover" href={back}>
        Return to your account
      </a>
      {' and come back here.'}
    </div>
  );
};

export default MasqueradeNotice;
